<template lang="pug">
div(
    :class="styles.root"
)
    span
    span
    span
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

export default Vue.extend({
    name: 'Loader',
    setup() {
        const styles = useCssModule()

        return {
            styles,
        }
    },
})
</script>

<style module lang="scss" src="./Preloader.module.scss" />
